class VanillaScrollActive {
  constructor(jsPageSelector, headerActiveClass) {
    this.jsPage = document.querySelector(jsPageSelector);
    this.headerActiveClass = headerActiveClass;

    if (!this.jsPage) return;

    this._topAddClassInit();
  }

  _topAddClassInit() {
    window.addEventListener("scroll", () => {
      const scrollY = window.scrollY || window.pageYOffset;

      // 1rem = 10px 前提
      const threshold = window.innerWidth >= 1280 ? 430 : 356;

      if (scrollY > threshold) {
        this.jsPage.classList.add(this.headerActiveClass);
      } else {
        this.jsPage.classList.remove(this.headerActiveClass);
      }
    });
  }
}

export default VanillaScrollActive;
